<style>
    .collapse-icon [data-toggle=collapse]:after {
        background-image: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23ffffff'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>");
    }
</style>
<template>
    <div v-if="email && reportStore.reports[email].isReportFetch" class="d-flex justify-content-end">
        <a
            @click="exportToPDF"
            href="#"
            class="btn btn-sm btn-primary mb-50 waves-effect waves-light"
        >
            <span class="d-flex align-items-center">
                <vue-feather type="download" class="mr-50" size="14" />
                Export to PDF
            </span>
        </a>
    </div>
    <section v-if="email && reportStore.reports[email].isReportFetch">
        <div class="card chat-widget">
            <div class="card-header bg-primary">
                <div class="d-flex w-100 justify-content-between">
                    <h5 class="mb-0 text-white">
                        Credit Scores
                    </h5>
                    <h5 class="mb-0 text-white">
                        Report Pull Date:
                        {{
                            reportStore.reports[email].report.details
                            ?
                            formatDate(reportStore.reports[email].report.details.pull_date, 'M/D/YYYY')
                            :
                            '-'
                        }}
                    </h5>
                    <h5 class="mb-0 text-white">
                        Report Date:
                        {{
                            reportStore.reports[email].report.details
                            ?
                            formatDate(reportStore.reports[email].report.details.report_date, 'M/D/YYYY')
                            :
                            '-'
                        }}
                    </h5>
                </div>
            </div>
            <div class="card-body p-0">
                <div class="row">
                    <div v-for="(creditScore,index) in reportStore.getCreditScores()" class="col-sm-4 col-12 d-flex flex-column flex-wrap text-center border-right py-1">
                        <apexchart
                            height="270"
                            type="radialBar"
                            :options="reportStore.getChartOptions(creditScore, 'radial')"
                            :series="[reportStore.getChartSeries(creditScore.credit_score)[0]]"
                        />
                        <!-- <p class="card-text">{{ reportStore.getChartSeries(creditScore.credit_score)[0] }} %</p> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="card chat-widget">
            <div class="card-header bg-primary">
                <div class="d-flex justify-content-between w-100">
                    <h5 class="mb-0 text-white">
                        Credit Score Factor Updates
                    </h5>
                    <h5 class="mb-0 text-white">
                        Report Pull Date:
                        {{
                            reportStore.reports[email].report.details
                            ?
                            formatDate(reportStore.reports[email].report.details.pull_date, 'M/D/YYYY')
                            :
                            '-'
                        }}
                    </h5>
                    <h5 class="mb-0 text-white">
                        Report Date:
                        {{
                            reportStore.reports[email].report.details
                            ?
                            formatDate(reportStore.reports[email].report.details.report_date, 'M/D/YYYY')
                            :
                            '-'
                        }}
                    </h5>
                </div>
            </div>
            <div class="card-body p-0">
                <div class="row">
                    <div class="col-sm-3 col-12 d-flex flex-column flex-wrap text-center border-right py-1">
                        <h1 class="font-large-5 font-weight-bolder mt-2 mb-0">
                            {{ reportStore.count.deletedAccounts }}
                        </h1>
                        <p class="card-text">Deleted Accounts</p>
                    </div>
                    <div class="col-sm-3 col-12 d-flex flex-column flex-wrap text-center border-right py-1">
                        <h1 class="font-large-5 font-weight-bolder mt-2 mb-0">
                            {{ reportStore.count.newPositiveAccounts }}
                        </h1>
                        <p class="card-text">Updated to Positive</p>
                    </div>
                    <div class="col-sm-3 col-12 d-flex flex-column flex-wrap text-center border-right py-1">
                        <h1 class="font-large-5 font-weight-bolder mt-2 mb-0">
                            {{ reportStore.count.newNegativeAccounts }}
                        </h1>
                        <p class="card-text">Updated to Negative</p>
                    </div>
                    <div class="col-sm-3 col-12 d-flex flex-column flex-wrap text-center border-right py-1">
                        <h1 class="font-large-5 font-weight-bolder mt-2 mb-0">
                            {{ reportStore.count.newAccounts }}
                        </h1>
                        <p class="card-text">Added Accounts</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row collapse-margin collapse-icon">
            <div v-for="(account, loop) in reportStore.reports[email].report.accounts" class="col-12 col-md-6">
                <div class="card">
                    <div
                        class="card-header bg-primary"
                        data-toggle="collapse"
                        :data-target="`#account_${loop}`"
                    >
                        <div class="d-flex align-items-center">
                            <h5 class="mb-0 text-white lead collapse-title">
                                {{ reportStore.getAccountDetail(account).furnisher_name }}
                                <template v-if="account[0].letters.length > 0 || account[1].letters.length > 0 || account[2].letters.length > 0">
                                    (In Dispute)
                                </template>
                            </h5>
                        </div>
                    </div>
                    <div
                        class="card-body p-0 collapse"
                        :id="`account_${loop}`"
                        :class="{
                            show:
                            account[0].letters.length > 0
                            ||
                            account[1].letters.length > 0
                            ||
                            account[2].letters.length > 0
                        }"
                    >
                        <div
                            class="table-responsive"
                        >
                            <table class="table table-success table-striped table-hover mb-0 border-bottom">
                                <thead>
                                    <tr>
                                        <th class="bg-white" style="width:100px"></th>
                                        <th class="bg-white" style="width:100px">
                                            <img :src="reportStore.images.transunion" alt="image" width="125" height="125" class="d-block">
                                            <p
                                                v-if="reportStore.reports[email].haveOldReport"
                                                data-toggle="modal"
                                                :data-target="`#account_before_after_modal_${account[0].id}`"
                                                class="text-primary mb-0"
                                                style="font-size:12px;cursor: pointer;"
                                            >
                                                <u>View Details</u>
                                            </p>
                                            <account-before-after-modal
                                                v-if="reportStore.reports[email].haveOldReport"
                                                :before-account="reportStore.previousReport(account[0], column = 'all')"
                                                :after-account="account[0]"
                                                :id="`account_before_after_modal_${account[0].id}`"
                                                :email="email"
                                            />
                                        </th>
                                        <th class="bg-white" style="width:100px">
                                            <img :src="reportStore.images.experian" alt="image" width="125" height="125" class="d-block">
                                            <p
                                                v-if="reportStore.reports[email].haveOldReport"
                                                data-toggle="modal"
                                                :data-target="`#account_before_after_modal_${account[1].id}`"
                                                class="text-primary mb-0"
                                                style="font-size:12px;cursor: pointer;"
                                            >
                                                <u>View Details</u>
                                            </p>
                                            <account-before-after-modal
                                                v-if="reportStore.reports[email].haveOldReport"
                                                :before-account="reportStore.previousReport(account[1], column = 'all')"
                                                :after-account="account[1]"
                                                :id="`account_before_after_modal_${account[1].id}`"
                                                :email="email"
                                            />
                                        </th>
                                        <th class="bg-white" style="width:100px">
                                            <img :src="reportStore.images.equifax" alt="image" width="125" height="125" class="d-block">
                                            <p
                                                v-if="reportStore.reports[email].haveOldReport"
                                                data-toggle="modal"
                                                :data-target="`#account_before_after_modal_${account[2].id}`"
                                                class="text-primary mb-0"
                                                style="font-size:12px;cursor: pointer;"
                                            >
                                                <u>View Details</u>
                                            </p>
                                            <account-before-after-modal
                                                v-if="reportStore.reports[email].haveOldReport"
                                                :before-account="reportStore.previousReport(account[2], column = 'all')"
                                                :after-account="account[2]"
                                                :id="`account_before_after_modal_${account[2].id}`"
                                                :email="email"
                                            />
                                        </th>
                                    </tr>
                                </thead>
                                <tbody class="table-striped">
                                    <tr>
                                        <td>Account Number</td>
                                        <td>
                                            <p class="mb-0">
                                                {{ account[0].account_number }}
                                            </p>
                                        </td>
                                        <td>
                                            <p class="mb-0">
                                                {{ account[1].account_number }}
                                            </p>
                                        </td>
                                        <td>
                                            <p class="mb-0">
                                                {{ account[2].account_number }}
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Account Status</td>
                                        <td>
                                            <p class="mb-0">
                                                {{ account[0].account_status }}
                                            </p>
                                        </td>
                                        <td>
                                            <p class="mb-0">
                                                {{ account[1].account_status }}
                                            </p>
                                        </td>
                                        <td>
                                            <p class="mb-0">
                                                {{ account[2].account_status }}
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Payment Status</td>
                                        <td>
                                            <p class="mb-0">
                                                {{ account[0].payment_status }}
                                            </p>
                                        </td>
                                        <td>
                                            <p class="mb-0">
                                                {{ account[1].payment_status }}
                                            </p>
                                        </td>
                                        <td>
                                            <p class="mb-0">
                                                {{ account[2].payment_status }}
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Comments</td>
                                        <td>
                                            <p class="mb-0">
                                                {{ account[0].comments }}
                                            </p>
                                        </td>
                                        <td>
                                            <p class="mb-0">
                                                {{ account[1].comments }}
                                            </p>
                                        </td>
                                        <td>
                                            <p class="mb-0">
                                                {{ account[2].comments }}
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Action Taken</td>
                                        <td>
                                            <p v-if="account[0].letters.length > 0" class="mb-0">
                                                <div class="badge badge-primary bg-light-warning">
                                                    <vue-feather type="pie-chart" />
                                                </div>
                                                In Dispute
                                            </p>
                                            <p v-else class="mb-0">
                                                -
                                            </p>
                                        </td>
                                        <td>
                                            <p v-if="account[1].letters.length > 0" class="mb-0">
                                                <div class="badge badge-primary bg-light-warning">
                                                    <vue-feather type="pie-chart" />
                                                </div>
                                                In Dispute
                                            </p>
                                            <p v-else class="mb-0">
                                                -
                                            </p>
                                        </td>
                                        <td>
                                            <p v-if="account[2].letters.length > 0" class="mb-0">
                                                <div class="badge badge-primary bg-light-warning">
                                                    <vue-feather type="pie-chart" />
                                                </div>
                                                In Dispute
                                            </p>
                                            <p v-else class="mb-0">
                                                -
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Reason</td>
                                        <td>
                                            <p v-if="account[0].letters.length > 0" class="mb-0">
                                                {{ account[0].letters[0].pivot.reason }}
                                            </p>
                                            <p v-else class="mb-0">
                                                -
                                            </p>
                                        </td>
                                        <td>
                                            <p v-if="account[1].letters.length > 0" class="mb-0">
                                                {{ account[1].letters[0].pivot.reason }}
                                            </p>
                                            <p v-else class="mb-0">
                                                -
                                            </p>
                                        </td>
                                        <td>
                                            <p v-if="account[2].letters.length > 0" class="mb-0">
                                                {{ account[2].letters[0].pivot.reason }}
                                            </p>
                                            <p v-else class="mb-0">
                                                -
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Results of Dispute</td>
                                        <td>
                                            <p class="mb-0">
                                                -
                                            </p>
                                        </td>
                                        <td>
                                            <p class="mb-0">
                                                -
                                            </p>
                                        </td>
                                        <td>
                                            <p class="mb-0">
                                                -
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Status on Previous Report</td>
                                        <td>
                                            <p class="mb-0">
                                                {{ reportStore.previousReport(account[0], column = "comments") }}
                                            </p>
                                        </td>
                                        <td>
                                            <p class="mb-0">
                                                {{ reportStore.previousReport(account[1], column = "comments") }}
                                            </p>
                                        </td>
                                        <td>
                                            <p class="mb-0">
                                                {{ reportStore.previousReport(account[2], column = "comments") }}
                                            </p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-none" ref="thirty_day_report">
            <div class="card chat-widget border-primary">
                <div class="card-header bg-primary">
                    <div class="d-flex align-items-center">
                        <h5 class="mb-0 text-white">
                            Credit Scores
                        </h5>
                    </div>
                </div>
                <div class="card-body p-0">
                    <div class="row">
                        <div v-for="(creditScore,index) in reportStore.getCreditScores()" class="col-sm-4 col-12 d-flex flex-column flex-wrap text-center border-right py-1">
                            <h1 class="font-large-5 font-weight-bolder mt-2 mb-0">
                                {{ creditScore.credit_score }}
                            </h1>
                            <p class="card-text">{{ creditScore.credit_reporting_agency.name }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card chat-widget border-primary">
                <div class="card-header bg-primary">
                    <div class="d-flex align-items-center">
                        <h5 class="mb-0 text-white">
                            Credit Score Factor Updates
                        </h5>
                    </div>
                </div>
                <div class="card-body p-0">
                    <div class="row">
                        <div class="col-sm-3 col-12 d-flex flex-column flex-wrap text-center border-right py-1">
                            <h1 class="font-large-5 font-weight-bolder mt-2 mb-0">
                                {{ reportStore.count.deletedAccounts }}
                            </h1>
                            <p class="card-text">Deleted</p>
                        </div>
                        <div class="col-sm-3 col-12 d-flex flex-column flex-wrap text-center border-right py-1">
                            <h1 class="font-large-5 font-weight-bolder mt-2 mb-0">
                                {{ reportStore.count.newPositiveAccounts }}
                            </h1>
                            <p class="card-text">Update to Positive</p>
                        </div>
                        <div class="col-sm-3 col-12 d-flex flex-column flex-wrap text-center border-right py-1">
                            <h1 class="font-large-5 font-weight-bolder mt-2 mb-0">
                                {{ reportStore.count.newNegativeAccounts }}
                            </h1>
                            <p class="card-text">Update to Negative</p>
                        </div>
                        <div class="col-sm-3 col-12 d-flex flex-column flex-wrap text-center border-right py-1">
                            <h1 class="font-large-5 font-weight-bolder mt-2 mb-0">
                                {{ reportStore.count.newAccounts }}
                            </h1>
                            <p class="card-text">Added</p>
                        </div>
                    </div>
                </div>
            </div>
            <div v-for="(account, loop) in reportStore.reports[email].report.accounts" class="card">
                <div class="card-header bg-primary">
                    <div class="d-flex align-items-center">
                        <h5 class="mb-0 text-white">
                            {{ reportStore.getAccountDetail(account).furnisher_name }}
                        </h5>
                    </div>
                </div>
                <div class="card-body p-0">
                    <div
                        class="table-responsive"
                    >
                        <table class="table table-success table-striped table-hover mb-0 border-bottom">
                            <tbody class="table-striped">
                                <tr>
                                    <th class="bg-white" style="width:100px"></th>
                                    <th class="bg-white" style="width:100px">
                                        Transunion
                                    </th>
                                    <th class="bg-white" style="width:100px">
                                        Experian
                                    </th>
                                    <th class="bg-white" style="width:100px">
                                        Equifax
                                    </th>
                                </tr>
                                <tr>
                                    <td>Account Number</td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[0].account_number }}
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[1].account_number }}
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[2].account_number }}
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Account Status</td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[0].account_status }}
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[1].account_status }}
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[2].account_status }}
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Payment Status</td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[0].payment_status }}
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[1].payment_status }}
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[2].payment_status }}
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Comments</td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[0].comments }}
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[1].comments }}
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[2].comments }}
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Action Taken</td>
                                    <td>
                                        <p v-if="account[0].letters.length > 0" class="mb-0">
                                            <div class="badge badge-primary bg-light-warning">
                                                <vue-feather type="pie-chart" />
                                            </div>
                                            In Dispute
                                        </p>
                                        <p v-else class="mb-0">
                                            -
                                        </p>
                                    </td>
                                    <td>
                                        <p v-if="account[1].letters.length > 0" class="mb-0">
                                            <div class="badge badge-primary bg-light-warning">
                                                <vue-feather type="pie-chart" />
                                            </div>
                                            In Dispute
                                        </p>
                                        <p v-else class="mb-0">
                                            -
                                        </p>
                                    </td>
                                    <td>
                                        <p v-if="account[2].letters.length > 0" class="mb-0">
                                            <div class="badge badge-primary bg-light-warning">
                                                <vue-feather type="pie-chart" />
                                            </div>
                                            In Dispute
                                        </p>
                                        <p v-else class="mb-0">
                                            -
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Reason</td>
                                    <td>
                                        <p v-if="account[0].letters.length > 0" class="mb-0">
                                            {{ account[0].letters[0].pivot.reason }}
                                        </p>
                                        <p v-else class="mb-0">
                                            -
                                        </p>
                                    </td>
                                    <td>
                                        <p v-if="account[1].letters.length > 0" class="mb-0">
                                            {{ account[1].letters[0].pivot.reason }}
                                        </p>
                                        <p v-else class="mb-0">
                                            -
                                        </p>
                                    </td>
                                    <td>
                                        <p v-if="account[2].letters.length > 0" class="mb-0">
                                            {{ account[2].letters[0].pivot.reason }}
                                        </p>
                                        <p v-else class="mb-0">
                                            -
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Results of Dispute</td>
                                    <td>
                                        <p class="mb-0">
                                            -
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            -
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            -
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Status on Previous Report</td>
                                    <td>
                                        <p class="mb-0">
                                            {{ reportStore.previousReport(account[0], column = "comments") }}
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ reportStore.previousReport(account[1], column = "comments") }}
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ reportStore.previousReport(account[2], column = "comments") }}
                                        </p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <loading v-else />
</template>

<script>
    import { ref, reactive, computed } from 'vue'
    import { useReportStore } from '../../stores/ReportStore.js'
    import { useUserStore } from '../../stores/UserStore.js'
    import Loader from './Loader'
    import VueApexCharts from "vue3-apexcharts";
    import AccountBeforeAfterModal from './modals/AccountBeforeAfter.vue'
    import html2pdf from "html2pdf.js";
    import Swal from 'sweetalert2'
    import { formatDate } from '../../utilities/_helpers'
    export default {
        mounted() {
            if (_.isNull(this.email) && this.$route.params.client) {
                this.email = this.clientEmail;
                this.reportStore.getReport();
            }
        },
        components: {
            'loading': Loader,
            apexchart: VueApexCharts,
            'account-before-after-modal': AccountBeforeAfterModal
        },
        props: {
            clientEmail: {
                type: String,
                default: null
            }
        },
        setup() {
            return {
                reportStore: useReportStore(),
                userStore: useUserStore(),
                email: ref(null),
                html2pdf: html2pdf,
                formatDate: formatDate
            }
        },
        watch: {
            'userStore.user'(value) {
                if (value != null) {
                    if (!value.isBusinessUser) {
                        this.email = value.email;
                    }
                    else {
                        this.email = this.clientEmail;
                    }
                    this.reportStore.getReport();
                }
            },
        },
        computed: {
        },
        mounted() {
            let value = this.userStore.user;
            if (value != null) {
                if (!value.isBusinessUser) {
                    this.email = value.email;
                }
                else {
                    this.email = this.clientEmail;
                }
                if (!this.reportStore.reports[this.email]) {
                    this.reportStore.getReport();
                }
            }
        },
        methods: {

            exportToPDF() {
                Swal.fire({
                    title: 'Generating Report',
                    html: `<span class="spinner-border spinner-border-sm  mr-50" role="status" aria-hidden="true"></span> PDF is in Progress`,
                    showConfirmButton: false,
                    allowOutsideClick: false
                });

                setTimeout(() => {
                    var opt = {
                        margin: 0,
                        filename: 'thirty_day_report.pdf',
                        image: { type: 'png', quality: 0.20 },
                        html2canvas: {
                            scale: 2,
                            // useCORS: true,
                            // allowTaint:true,
                        },
                        jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
                    };
                    html2pdf().set(opt).from(this.$refs.thirty_day_report.innerHTML).save().then((response)=>{
                        Swal.close();
                    });
                }, "1000");
            },
        },
    }
</script>
